import { render, staticRenderFns } from "./IframeModel.vue?vue&type=template&id=12c7d41e&scoped=true&"
import script from "./IframeModel.vue?vue&type=script&lang=ts&"
export * from "./IframeModel.vue?vue&type=script&lang=ts&"
import style0 from "./IframeModel.vue?vue&type=style&index=0&id=12c7d41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7d41e",
  null
  
)

export default component.exports